import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import { formatDate } from 'lib/functions/utils';
import React from 'react';

type EditOperationDateDialogProps = {
  open: boolean;
  onClose: () => void;
  operationDate?: Date;
  setOperationDate: (newDate: Date) => void;
};

function EditOperationDateDialog({
  open,
  onClose,
  operationDate,
  setOperationDate,
}: EditOperationDateDialogProps) {
  const handleEditOperationDate = (event: any) => {
    const inputDate = new Date(event.target.value);
    inputDate.setUTCHours(12);
    setOperationDate(inputDate);
    onClose();
  };
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Editar fecha de operación</DialogTitle>
        <DialogContent style={{ paddingTop: 12 }}>
          <TextField
            fullWidth
            label="Fecha de solicitud"
            type="date"
            value={operationDate ? formatDate(operationDate) : null}
            onChange={handleEditOperationDate}
          />
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={handleEditOperationDate}>
            Cerrar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EditOperationDateDialog;
